import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.LOAD_STEPS](state, steps) {
    steps.forEach((step) => {
      let formatStep = { ...step };
      if (step.type === "form") {
        let newFormat = [];
        Object.keys(step.schema).forEach((key) => {
          newFormat.push({ id: key, label: step.schema[key].description, type: step.schema[key].type });
        });
        formatStep["schema"] = newFormat;
      }
      state.assistantSteps.push(formatStep);
    });
  },
  [MutationsType.ADD_STEP](state, step) {
    state.assistantSteps.push(step);
  },
  [MutationsType.UPDATE_STEP](state, { updates }) {
    state.assistantSteps.forEach((step, index) => {
      if (step.id === updates.id) {
        Vue.set(state.assistantSteps, index, { ...step, ...updates, isVisible: step.isVisible });
      }
    });
  },
  [MutationsType.UPDATE_STEP_ALL_ATRIBUTES](state, { updates }) {
    let findIndex = -1;
    state.assistantSteps.forEach((step, index) => {
      if (step.id === updates.id) {
        Vue.set(state.assistantSteps, index, { ...step, ...updates, isVisible: step.isVisible });
        findIndex = index;
      }
    });
    if (findIndex !== -1) {
      const step = state.assistantSteps[findIndex];
      Vue.set(state.assistantSteps, findIndex, { ...step, ...updates, isVisible: updates.isVisible });
    }
  },
  [MutationsType.DELETE_STEP](state, payload) {
    let index = state.assistantSteps.findIndex((step) => {
      return step.id === payload.id;
    });
    if (index >= 0) state.assistantSteps.splice(index, 1);
  },
  [MutationsType.ADD_OPTION_TO_STEP](state, { stepIndex, option }) {
    const step = state.assistantSteps[stepIndex];
    if (!step.options) {
      Vue.set(step, "options", []);
    }
    step.options.push(option);
  },
  [MutationsType.UPDATE_OPTION_TO_STEP](state, { stepIndex, optionIndex, option }) {
    const step = state.assistantSteps[stepIndex];
    Vue.set(step.options, optionIndex, option);
  },
  [MutationsType.REMOVE_CURRENT_ASSISTANT_STEP_OPTION](state, payload) {
    let index = state.assistantSteps.findIndex((step) => step.id === payload.id);
    if (index !== -1) {
      let optionIndex = state.assistantSteps[index].options.findIndex((option) => option.id === payload.option.id);
      if (optionIndex !== -1) {
        state.assistantSteps[index].options.splice(optionIndex, 1);
      }
    }
  },
  [MutationsType.SET_CURRENT_STEP_INDEX](state, index) {
    state.currentStepIndex = index;
  },
  [MutationsType.SELECT_OPTION](state, { stepIndex, optionId }) {
    const step = state.assistantSteps[stepIndex];
    if (step && step.options) {
      step.options.forEach((option) => {
        option.selected = option.id === optionId;
      });
    }
  },
  [MutationsType.REMOVE_OPTION_FROM_STEP](state, { stepIndex, optionId }) {
    const step = state.assistantSteps[stepIndex];
    if (step && step.options) {
      const optionIndex = step.options.findIndex((option) => option.id === optionId);
      if (optionIndex !== -1) {
        step.options.splice(optionIndex, 1);
      }
    }
  },
  [MutationsType.ADD_EXTRA_FILE_TO_STEP](state, { stepIndex, extraFile }) {
    const step = state.assistantSteps[stepIndex];
    if (!step.extra_files) {
      Vue.set(step, "extra_files", []);
    }
    step.extra_files.push(extraFile);
  },
  [MutationsType.REMOVE_FILE_EXTRA_FROM_STEP](state, { stepIndex, fileId }) {
    const step = state.assistantSteps[stepIndex];
    if (step && step.extra_files) {
      const fileIndex = step.extra_files.findIndex((file) => file.id === fileId);
      if (fileIndex !== -1) {
        step.extra_files.splice(fileIndex, 1);
      }
    }
  },
  [MutationsType.RESET_ASSISTANT](state) {
    state.assistantSteps = [];
    state.currentStepIndex = 0;
  },
  [MutationsType.ADD_TRIGGER_TO_STEP_OPTION](state, payload) {
    console.log("ADD_TRIGGER_TO_STEP_OPTION", payload);
    const step = state.assistantSteps[payload.stepIndex];
    console.log("ADD_TRIGGER_TO_STEP_OPTION step", step);
    if (step.options?.length) {
      const optionInd = step.options.findIndex((o) => o.id === payload.optionId);
      console.log("optionInd", optionInd);
      Vue.set(step.options[optionInd], "triggers", [
        ...(step.options[optionInd].triggers || []),
        {
          actionTrigger: "",
          subActionTrigger: "",
        },
      ]);
    }
  },
  [MutationsType.REMOVE_TRIGGER_FROM_STEP_OPTION](state, payload) {
    const step = state.assistantSteps[payload.stepIndex];
    if (step.options?.length) {
      const optionInd = step.options.findIndex((o) => o.id === payload.optionId);
      if (step.options[optionInd].triggers?.length) {
        step.options[optionInd].triggers.splice(payload.triggerInd, 1);
      }
    }
  },
};
